import { Column } from "@faire/web/slate/Layout";
import { LoadingSkeleton } from "@faire/web/slate/LoadingSkeleton";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

export const SuppliersPageHeaderLoadingSkeleton: React.FC = () => {
  return (
    <Column data-test-id="header-placeholder" className="my-8 px-4 lg:px-12">
      <LoadingSkeleton
        width={{ mobileAndAbove: "200px", tabletAndAbove: "350px" }}
        height="20px"
      />
      <Spacer width="1x" />
      <LoadingSkeleton
        width={{ mobileAndAbove: "100%", tabletAndAbove: "700px" }}
        height="40px"
      />
      <Spacer height="1x" />
      <LoadingSkeleton
        width={{ mobileAndAbove: "150px", tabletAndAbove: "200px" }}
        height="20px"
      />
    </Column>
  );
};
